export const API_URL = 'https://forkify-api.herokuapp.com/api/v2/recipes';
export const TIMEOUT_SEC = 10;
export const RES_PER_PAGE = 10;
export const KEY = '1fe58444-c625-45a6-b81a-ee6662e64c14';
export const MODAL_CLOSE_SEC = 2.5;
